































































































































































import { Component, Vue } from "vue-property-decorator";
import { SelectorMap } from "@/utility/TemplateOptions";
import NotesPage from "./NotesPage.vue";
import Selector from "@/utility/Selector";

@Component({
  components: {
    NotesPage,
  },
})
export default class Dementia extends Vue {
  private selectors: SelectorMap = {};
  private selectorsLoaded = false;

  private chosenNestedSelectors(sel: Selector, isArray: boolean) {
    const prefixedSelectorValues = sel.value!.map((x: any) => `${sel.nestedControlPrefix} ${x}`);
    return Object.fromEntries(
      Object.entries(this.selectors).filter(
        (e, i, a) => {
          let arrayCheck = (Array.isArray(e[1].options) === isArray)
          return prefixedSelectorValues.includes(e[0]) && arrayCheck;
        }
      ).map(([k,v]) => [k.substring(sel.nestedControlPrefix!.length),v]));
  }

  private hasOther(selector: Selector) {
    return selector.value!.includes('OTHER');
  }
}

